import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';

export interface CountryData {
  key: any;
  id: any;
  alpha2: string;
  name: string;
  text: string;
  translationKey: string;
}

@Injectable()
export class CountryService {

  private countries: Promise<CountryData[]>;

  constructor(private http: HttpClient) {
    this.countries = firstValueFrom(
      this.http.get<CountryData[]>('assets/i18n/countries/countries.json')
    ).catch(() => []); // In case of error, fallback to empty array
  }

  async getCountries(): Promise<CountryData[]> {
    const countries = await this.countries;

    countries.forEach(element => {
      element.key = element.alpha2;
      element.id = element.alpha2;
      element.translationKey = 'PORTAL_COUNTRIES.' + element.alpha2;
      element.text = element.name;
    });
    return countries;
  }
}
